import { decompress } from './token';

export default function richTextEditorDirective($sce, $timeout, richTextEditorService) {
  return {
    template: '<div ng-style="style" ng-bind-html="trustedContent"></div>',
    restrict: 'E',
    scope: {
      content: '=',
      editorId: '@',
      options: '<',
      tokens: '<',
      tokensEnabled: '<',
    },
    replace: true,
    link(scope, $element, attrs) { // eslint-disable-line no-unused-vars
      // Prevent editor height from jumping after initialization
      // Set element height to config value
      const height = scope.options.height || richTextEditorService.config.height;
      scope.style = { 'min-height': `${height}px` };
      scope.trustedContent = null;
      $element.css('opacity', 0);
      scope.$watch(
        () => scope.tokens.hasData,
        (hasData) => {
          if (!hasData) {
            return;
          }
          if (!scope.content) {
            scope.trustedContent = '';
          } else {
            const hydratedContent = decompress(scope.content, scope.tokens);

            // We must trust the html content so that Angular does not strip any
            // custom attributes we are using (e.g., "rte-token").
            // https://docs.angularjs.org/api/ng/service/$sce#trustAsHtml
            // https://docs.angularjs.org/api/ng/service/$sce#show-me-an-example-using-sce-
            // https://docs.angularjs.org/api/ng/directive/ngBindHtml
            scope.trustedContent = $sce.trustAsHtml(hydratedContent);
          }
          // We take the editor creation out of the digest cycle
          // because we need the template element to exist in the DOM first
          $timeout(() => {
            richTextEditorService.create(scope.editorId, $element, scope.options, scope.tokensEnabled);
            $element.animate({ opacity: 1 });
          }, 0);
        }
      );
    },
  };
}

richTextEditorDirective.$inject = [
  '$sce',
  '$timeout',
  'richTextEditorService',
];
